import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import api, {standardApiSlice} from 'service/api'

export const register = createAsyncThunk('register/register', api.post('/register'))

export const registerSlice = createSlice(standardApiSlice('register', register))

export const { clearErrors } = registerSlice.actions

export default registerSlice.reducer